import { render, staticRenderFns } from "./AccountSettingsAccount.vue?vue&type=template&id=0faffd6d"
import script from "./AccountSettingsAccount.vue?vue&type=script&lang=js"
export * from "./AccountSettingsAccount.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsAccount.vue?vue&type=style&index=0&id=0faffd6d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports